import Route from '@ember/routing/route';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class MaintenanceRoute extends Route {
  /**
   * @type {Ember.Service}
   */
  @service router;
  @service store;

  okayToTransition = false;

  activate(transition) {
    super.activate(...arguments);
    this.set('okayToTransition', false);
    trackPageViewFromTransition(this, transition, '/maintenance/');
  }

  @action
  willTransition(transition) {
    const { okayToTransition } = this

    if(!okayToTransition) {
      transition.abort();

      // Perform a dummy lookup on the server just to see if it's out of
      // Maintenance Mode.  If you get a valid response, proceed with the
      // transition.  If not, and you can verify the error is a 503, just
      // stay on the Maintenance Page

      this.store.find('user', 1).then(
        () => {
          this.set('okayToTransition', true);
          this.router.replaceWith(transition.targetName);
        },
        (errorObj) => {
          if (Number.parseInt(errorObj.errors.firstObject?.status) !== 503) {
            this.set('okayToTransition', true);
            this.router.replaceWith(transition.targetName);
          }
        }
      );
    }
  }
}

export default MaintenanceRoute;
